export {
  createLivechatWidget,
  type LivechatWidgetInstance,
  type LivechatWidgetOptions,
  type LivechatEnv,
  type LivechatChannelConfig,
} from "./livechatWidget";

import {
  createLivechatWidget,
  type LivechatWidgetInstance,
  type LivechatWidgetOptions,
} from "./livechatWidget";

/**
 * 一行初始化：创建并 mount，返回实例（可 destroy/close/open）。
 */
export function mountLivechatWidget(
  options: LivechatWidgetOptions = {}
): LivechatWidgetInstance {
  const widget = createLivechatWidget(options);
  widget.mount();
  return widget;
}

